
import React, { useMemo, useState } from 'react'
import { useSelector } from 'react-redux'

import useTranslation from '../../../Hooks/UseTranslation'

import NotificationsDialog from '../../../Components/NotificationsDialog/NotificationsDialog'

const ToggleNotifications = () => {

  const { t } = useTranslation()

  const notifications = useSelector((state: any) => state.NotificationsReducer.result)

  const [ showNotifications, setShowNotifications ] = useState(false)

  const notRead = useMemo(() => {

    if (!notifications) {

      return 0
    }

    return notifications.filter((notification: any) => notification.status === 'not_read').length
  }, [])

  return (
    <>
      <div
        className="right-dropdown svg-icon-menu cursor-pointer"
        style={{ paddingTop: 6 }}
        onClick={() => setShowNotifications(true)}
      >

        <div className="svg-icon-container"
          style={{
            position: 'relative', // Agregamos posición relativa al contenedor
            width: 26,
            height: 26, // Añadimos altura para asegurar que el badge tenga espacio
            margin: 0,
          }}
        >

          {!notRead ? null : (
            <span
              className="badge badge-primary"
              style={{
                position: 'absolute',
                top: '0',
                right: '0',
                cursor: 'pointer',
                fontSize: 9
              }}
            >
              {notRead}
            </span>
          )}
          <span className="icon-notificaciones"></span>
        </div>
      </div>

      <NotificationsDialog
        show={showNotifications}
        title={t('NOTIFICATIONS:Title')}
        notifications={notifications}
        onHide={() => setShowNotifications(false)}
      />
    </>
  )
}

export default ToggleNotifications
